import React from 'react';
import './device-header.css';

const DeviceHeader = (props) => {
  const {
    deviceNameHeadingText,
    quantityHeadingText,
    unitPriceHeadingText,
    priceNameHeadingText,
  } = props;

  return (
    <div className="device-header">
      <div className="row">
        <div className="col-3 pl-sm-0">
          {deviceNameHeadingText}
        </div>
        <div className="col-3">
          {unitPriceHeadingText}
        </div>
        <div className="col-4">
          {quantityHeadingText}
        </div>
        <div className="col-2">
          {priceNameHeadingText}
        </div>
      </div>
    </div>
  );
};

export default DeviceHeader;
